<template>
  <div class="md-region-overview">
    <div class="md-region-cards">
      <div
        v-for="item in orderedRegions"
        :key="item.code"
        class="md-region-card"
        :class="{ 'md-rc-full': item.code === 'global', 'no-data': !item.count }"
        @click="$emit('select', item)"
      >
        <svg class="md-rc-icon" viewBox="0 0 44 44" v-html="regionSvgs[item.code] || regionSvgs.global"></svg>
        <div class="md-rc-info" :style="item.code === 'global' ? 'justify-content:center;text-align:center' : ''">
          <div class="md-rc-name">{{ item.title }}</div>
          <div class="md-rc-count-wrap" :style="item.code === 'global' ? 'justify-content:center' : ''">
            <span class="md-rc-count">{{ item.count || 0 }}</span>
            <span class="md-rc-unit">{{ $t('label.information.multilateral.dynamicsUnit') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultilateralRegionOverview',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      regionSvgs: {
        europe: '<path d="M 8 10 Q 16 6 26 8 L 32 12 Q 34 18 30 22 L 22 26 Q 12 24 8 18 Z" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/>',
        asia: '<path d="M 6 8 Q 18 4 36 6 L 40 12 Q 38 18 32 22 L 20 24 Q 10 20 6 14 Z" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/>',
        africa: '<path d="M 14 6 Q 24 4 30 8 L 34 16 Q 36 28 30 36 L 24 40 Q 16 38 14 30 L 12 18 Z" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/>',
        america: '<path d="M 10 4 Q 18 2 22 4 L 26 10 L 24 20 Q 22 30 18 40 L 14 42 Q 10 38 12 30 L 14 14 Z" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/>',
        oceania: '<path d="M 10 20 Q 18 16 30 18 L 36 22 Q 34 28 28 30 L 14 28 Q 8 26 10 22 Z" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/>',
        cross: '<circle cx="14" cy="14" r="5" fill="none" stroke="rgb(45,140,240)" stroke-width="1.5"/><circle cx="30" cy="14" r="5" fill="none" stroke="rgb(45,140,240)" stroke-width="1.5"/><path d="M 14 19 Q 22 28 30 19" fill="none" stroke="rgb(45,140,240)" stroke-width="1.5" stroke-dasharray="2,2"/>',
        global: '<circle cx="22" cy="22" r="16" fill="rgb(45,140,240)" opacity=".15" stroke="rgb(45,140,240)" stroke-width="1.5"/><ellipse cx="22" cy="22" rx="16" ry="8" fill="none" stroke="rgb(45,140,240)" stroke-width="1" opacity=".5"/><ellipse cx="22" cy="22" rx="8" ry="16" fill="none" stroke="rgb(45,140,240)" stroke-width="1" opacity=".5"/>'
      }
    }
  },
  computed: {
    orderedRegions () {
      const order = ['global', 'europe', 'asia', 'africa', 'america', 'oceania', 'cross']
      const list = this.data && this.data.length ? this.data.slice() : []
      return order
        .map(code => list.find(i => i.code === code))
        .filter(Boolean)
    }
  }
}
</script>

<style scoped>
.md-region-overview {
  padding: 8px 0;
}
.md-region-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}
.md-region-card {
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  padding: 6px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all .2s;
  position: relative;
  overflow: hidden;
}
.md-region-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 3px;
  background: rgb(45, 140, 240);
  opacity: 0;
  transition: opacity .2s;
}
.md-region-card:hover {
  border-color: rgb(45, 140, 240);
  box-shadow: 0 2px 8px rgba(45, 140, 240, .12);
}
.md-region-card:hover::before {
  opacity: 1;
}
.md-region-card.md-rc-full {
  grid-column: 1 / -1;
  justify-content: center;
  gap: 10px;
  padding: 8px 12px;
}
.md-rc-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}
.md-rc-full .md-rc-icon {
  width: 36px;
  height: 36px;
}
.md-rc-info {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.md-rc-name {
  font-size: 12px;
  color: #515a6e;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.md-rc-full .md-rc-name {
  font-size: 13px;
}
.md-rc-count-wrap {
  display: flex;
  align-items: baseline;
  gap: 2px;
  flex-shrink: 0;
}
.md-rc-count {
  font-size: 15px;
  font-weight: 700;
  color: rgb(45, 140, 240);
  line-height: 1;
}
.md-rc-full .md-rc-count {
  font-size: 20px;
}
.md-rc-unit {
  font-size: 10px;
  color: #808695;
}
.md-region-card.no-data .md-rc-count {
  color: #c5c8ce;
}
</style>
